"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineRequestElevatedEmailPermissionsCardWrapper = _interopRequireDefault(require("./TimelineRequestElevatedEmailPermissionsCardWrapper"));

var propTypes = {
  activityTabIsSelected: _propTypes.default.bool,
  emailTabIsSelected: _propTypes.default.bool,
  subject: _SubjectType.default.isRequired
};

function TimelineStickyEvent(_ref) {
  var activityTabIsSelected = _ref.activityTabIsSelected,
      emailTabIsSelected = _ref.emailTabIsSelected,
      subject = _ref.subject;

  if (!(activityTabIsSelected || emailTabIsSelected)) {
    return null;
  }

  return _react.default.createElement(_TimelineRequestElevatedEmailPermissionsCardWrapper.default, {
    subject: subject
  });
}

TimelineStickyEvent.propTypes = propTypes;
var _default = TimelineStickyEvent;
exports.default = _default;
module.exports = exports.default;